import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-location-mnd.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-location-mnd.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { Validators } from "@angular/forms";
import { AutoUnsub } from "../../../../../shared/decorators/autounsub.decorator";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { debounceTime } from "rxjs";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { CreateApplicationLocationMndConstants } from "./create-application-location-mnd.constants";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { MondiModuleService } from "../../../../../shared/services/modules/mondi-module.service";
import { MapTools } from "../../../../../map/shared/map.tools";
import { MapService } from "../../../../../map/shared/map.service";
import { RequestStatusService } from "../../../../../shared/services/request-status/request-status.service";
import { PopUpComponent } from "../../../../../shared/components/pop-up/pop-up.component";
let CreateApplicationLocationMndComponent = class CreateApplicationLocationMndComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    aflaModuleStrategyService;
    mondiService;
    appController;
    mapTools;
    mapService;
    modalService;
    requestStatusService;
    changeDetectorRefs;
    locationForm;
    descriptionLabel1 = CreateApplicationLocationMndConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = CreateApplicationLocationMndConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = CreateApplicationLocationMndConstants.DESCRIPTION_LABEL_3;
    descriptionLabel4 = CreateApplicationLocationMndConstants.DESCRIPTION_LABEL_4;
    modalOptions = CreateApplicationLocationMndConstants.MODAL_OPTION;
    validationMessages = CreateApplicationLocationMndConstants.VALIDATION_MESSAGES;
    regionFormControlName = CreateApplicationLocationMndConstants.REGION_FORM_CONTROL_NAME;
    areaFormControlName = CreateApplicationLocationMndConstants.AREA_FORM_CONTROL_NAME;
    wpuFormControlName = CreateApplicationLocationMndConstants.WPU_FORM_CONTROL_NAME;
    plantationFormControlName = CreateApplicationLocationMndConstants.PLANTATION_FORM_CONTROL_NAME;
    compartmentFormControlName = CreateApplicationLocationMndConstants.COMPARTMENT_FORM_CONTROL_NAME;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    regionLabel = CreateApplicationLocationMndConstants.REGION_LABEL;
    areaLabel = CreateApplicationLocationMndConstants.AREA_LABEL;
    wpuLabel = CreateApplicationLocationMndConstants.WPU_LABEL;
    plantationLabel = CreateApplicationLocationMndConstants.PLANTATION_LABEL;
    compartmentLabel = CreateApplicationLocationMndConstants.COMPARTMENT_LABEL;
    locationHeading = CreateApplicationLocationMndConstants.LOCATION_HEADING_LABEL;
    regionsFullList = [];
    areasFullList = [];
    wpusFullList = [];
    plantationsFullList = [];
    regions = [];
    areas = [];
    wpus = [];
    plantations = [];
    compartments = [];
    selectedLayer;
    selectedFeatureName;
    selectedFeatureKey;
    selectedCompartmentKey;
    locationDetail;
    lid;
    mapComponent;
    isMapLoaded = false;
    selectedGraphic = null;
    clearLayerGraphicsSubjectSubscription;
    mndTableDataLoadedSubjectSubscription;
    getMapDataObservableSubscription;
    getMappedLayerDataObservableSubscription;
    selectedMndLayerSubject;
    selectedMndAreaSubscription;
    selectedMndWPUSubscription;
    selectedMndPlantationSubscription;
    selectedCompartmentSubscription;
    constructor(createApplicationService, aflaModuleStrategyService, mondiService, appController, mapTools, mapService, modalService, requestStatusService, changeDetectorRefs) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.mondiService = mondiService;
        this.appController = appController;
        this.mapTools = mapTools;
        this.mapService = mapService;
        this.modalService = modalService;
        this.requestStatusService = requestStatusService;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.initForm();
        this.getMetadata();
        this.subscribeToLocation();
        this.loadMapData();
        this.changeDetectorRefs.detectChanges();
    }
    ngAfterViewInit() {
        this.mapService.actionMndRegionEnabled = true;
        this.mapService.actionMndAreaEnabled = true;
        this.mapService.actionMndWPUEnabled = true;
        this.mapService.actionMndPlantationEnabled = true;
        this.mapService.actionMndCompartmentEnabled = true;
    }
    ngOnDestroy() {
        this.mapService.actionMndCompartmentEnabled = false;
    }
    loadMetadata(stepMeta) {
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("locationForm");
        this.locationForm = form;
        this.locationForm.get("compartment").disable();
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    syncMapGeometries() {
        const geometries = [];
        const geomPoint = this.locationForm.get("point").value;
        const geomPolygon = this.locationForm.get("polygon").value;
        const geomLine = this.locationForm.get("polyline").value;
        if (geomPoint !== null) {
            geometries.push(geomPoint);
        }
        if (geomPolygon !== null) {
            geometries.push(geomPolygon);
        }
        if (geomLine !== null) {
            geometries.push(geomLine);
        }
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "Mondi module graphics", true);
        }
    }
    subscribeToLocation() {
        this.selectedMndLayerSubject = this.mapService.$selectedMndLayer.pipe(debounceTime(1000)).subscribe(property => {
            if (property !== null) {
                // this.checkIfLocationIsAlreadyLoaded(property);
                this.locationForm.reset();
                this.mapComponent.clearGraphics("Mondi module graphics");
                this.setLocationData(property.attributes, property.geometry);
            }
        });
    }
    checkIfLocationIsAlreadyLoaded(property) {
        const title = "Replace Location";
        const contentMessage = "An application can only have 1 Location. Do you want to replace the current location?";
        const propertyControl = this.locationForm.get("polygon").value;
        if (propertyControl) {
            this.requestStatusService.removeBusySpinner("GetPropertyDate");
            const dialogRef = this.modalService.open(PopUpComponent, this.modalOptions);
            dialogRef.componentInstance.title = title;
            dialogRef.componentInstance.contentMessage = contentMessage;
            dialogRef.componentInstance.data = true;
            dialogRef.result.then((replaceData) => {
                if (replaceData) {
                    this.locationForm.reset();
                    this.mapComponent.clearGraphics("Mondi module graphics");
                    this.setLocationData(property.attributes, property.geometry);
                }
            });
        }
        else {
            this.setLocationData(property.attributes, property.geometry);
        }
    }
    setLocationData(locationObject, geometry) {
        this.locationForm.get("region").setValue(this.locationDataAlternateColumnName(locationObject, "REGION_NAME", "region_name"), [Validators.required]);
        this.locationForm.get("area").setValue(this.locationDataAlternateColumnName(locationObject, "AREA_NAME", "area_name"), [Validators.required]);
        this.locationForm.get("wpu").setValue(this.locationDataAlternateColumnName(locationObject, "WPU_CODE", "wpu_code"), [Validators.required]);
        this.locationForm.get("plantation").setValue(this.locationDataAlternateColumnName(locationObject, "PLANTATION_CODE", "plantation_code"), [Validators.required]);
        this.locationForm.get("compartment").setValue(this.locationDataAlternateColumnName(locationObject, "SUB_COMPT_KEY", "sub_compt_key"), [Validators.required]);
        this.lid = this.locationDataAlternateColumnName(locationObject, "LID", "lid");
        if (this.lid) {
            this.lid = this.lid.toString();
        }
        this.locationForm.get("lid").setValue(this.lid);
        const regionName = this.locationDataAlternateColumnName(locationObject, "REGION_NAME", "region_name");
        const areaName = this.locationDataAlternateColumnName(locationObject, "AREA_NAME", "area_name");
        const wpuName = this.locationDataAlternateColumnName(locationObject, "WPU_NAME", "wpu_name");
        if (regionName != null && regionName !== "") {
            this.areas = this.areasFullList.filter(x => x.region === regionName);
        }
        if (areaName != null && areaName !== "") {
            this.wpus = this.wpusFullList.filter(x => x.area === areaName);
        }
        if (wpuName != null && wpuName !== "") {
            this.plantations = this.plantationsFullList.filter(x => x.wpu === wpuName);
        }
        if (locationObject.layerName != "area" && locationObject.layerName != "region") {
            var selectedFeature;
            if (this.locationDetail && this.locationDetail != "") {
                var _tempDetails = this.locationDetail.split(", ");
                if (_tempDetails.length > 1) {
                    this.locationDetail = _tempDetails[1];
                }
            }
            if (locationObject.layerName == "compartment") {
                selectedFeature = this.compartments.find(x => x.code == this.locationForm.get("compartment").value);
                this.locationDetail = `${selectedFeature.value}, ${this.locationDetail}`;
            }
            if (locationObject.layerName === "plantation") {
                selectedFeature = this.plantations.find(x => x.code === this.locationForm.get("plantation").value);
                this.locationDetail = `${selectedFeature.value}`;
            }
            if (locationObject.layerName === "workplanunit") {
                selectedFeature = this.wpus.find(x => x.code === this.locationForm.get("wpu").value);
                this.locationDetail = `${selectedFeature.value}`;
            }
            if (selectedFeature) {
                this.selectedFeatureKey = selectedFeature.code;
                this.selectedFeatureName = selectedFeature.value;
                this.selectedLayer = locationObject.layerName;
                if (selectedFeature.trial) {
                    this.locationForm.get("trial").setValue(selectedFeature.trial);
                }
                this.locationForm.get("selectedLayer").setValue(locationObject.layerName);
                this.locationForm.get("selectedFeatureName").setValue(this.selectedFeatureName);
                this.locationForm.get("selectedFeatureKey").setValue(this.selectedFeatureKey);
                this.locationForm.get("locationDetail").setValue(this.locationDetail);
                this.mapLayerData(this.selectedLayer, this.selectedFeatureKey);
                if (geometry.type === "point") {
                    this.locationForm.get("point").setValue(geometry);
                }
                else if (geometry.type === "polygon") {
                    this.locationForm.get("polygon").setValue(geometry);
                }
                else if (geometry.type === "polyline") {
                    this.locationForm.get("polyline").setValue(geometry);
                }
                this.syncMapGeometries();
            }
        }
        this.requestStatusService.removeBusySpinner("GetPropertyDate");
    }
    locationDataAlternateColumnName(locationObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(locationObject)) {
            if (key === name1) {
                returnVal = locationObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = locationObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = locationObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    loadMapData() {
        this.requestStatusService.showBusySpinner("LoadMapDataMnd");
        this.getMapDataObservableSubscription = this.mondiService.getMapDataObservable(this.createApplicationService.moduleID, {}).subscribe({
            next: data => {
                if (data.regions != null || data.regions.features.length > 0) {
                    data.regions.features.forEach(region => {
                        this.regions.push({ value: region.attributes.regionName, code: region.attributes.regionName });
                        this.regions.sort((a, b) => 0 - (a.value.toLowerCase() > b.value.toLowerCase() ? -1 : 1));
                    });
                }
                if (data.areas != null || data.areas.features.length > 0) {
                    data.areas.features.forEach(area => {
                        this.areas.push({
                            value: area.attributes.areaName,
                            code: area.attributes.areaName,
                            region: area.attributes.regionName
                        });
                        this.areas.sort((a, b) => 0 - (a.value.toLowerCase() > b.value.toLowerCase() ? -1 : 1));
                    });
                }
                if (data.wpUs != null || data.wpUs.features.length > 0) {
                    data.wpUs.features.forEach(wpu => {
                        this.wpus.push({
                            value: wpu.attributes.wpuName,
                            code: wpu.attributes.wpuCode,
                            region: wpu.attributes.regionName,
                            area: wpu.attributes.areaName
                        });
                        this.wpus.sort((a, b) => 0 - (a.value.toLowerCase() > b.value.toLowerCase() ? -1 : 1));
                    });
                }
                if (data.plantations != null || data.plantations.features.length > 0) {
                    data.plantations.features.forEach(plantation => {
                        this.plantations.push({
                            value: plantation.attributes.plantationName,
                            code: plantation.attributes.plantationCode,
                            region: plantation.attributes.regionName,
                            area: plantation.attributes.areaName,
                            wpu: plantation.attributes.wpuName
                        });
                        this.plantations.sort((a, b) => 0 - (a.value.toLowerCase() > b.value.toLowerCase() ? -1 : 1));
                    });
                }
                this.regionsFullList = this.regions;
                this.areasFullList = this.areas;
                this.wpusFullList = this.wpus;
                this.plantationsFullList = this.plantations;
                this.requestStatusService.removeBusySpinner("LoadMapDataMnd");
                this.changeDetectorRefs.detectChanges();
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(CreateApplicationLocationMndConstants.STEP_TITLE, error, CRUDOperation.Get);
                this.requestStatusService.removeBusySpinner("LoadMapDataMnd");
                this.changeDetectorRefs.detectChanges();
            }
        });
    }
    getCompartmentDataByCode() {
        this.requestStatusService.showBusySpinner("LoadMapDataMnd");
        const plantationCode = this.locationForm.get("plantation").value;
        const plantation = this.plantations.find(x => x.code === plantationCode);
        const params = {
            value: plantation.code,
            field: "PLANTATION_CODE"
        };
        this.getMapDataObservableSubscription = this.mondiService.getCompartmentsDataByCode(this.createApplicationService.moduleID, params).subscribe({
            next: data => {
                if (data != null || data.features.length > 0) {
                    data.features.forEach(compartment => {
                        this.compartments.push({
                            value: compartment.attributes.subCompt,
                            code: compartment.attributes.subComptKey,
                            trial: compartment.attributes.trial
                        });
                        this.compartments.sort((a, b) => 0 - (a.value.toLowerCase() > b.value.toLowerCase() ? -1 : 1));
                    });
                    if (this.selectedCompartmentKey !== "") {
                        this.locationForm.get("compartment").setValue(this.selectedCompartmentKey);
                    }
                }
                this.requestStatusService.removeBusySpinner("LoadMapDataMnd");
                this.changeDetectorRefs.detectChanges();
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(CreateApplicationLocationMndConstants.STEP_TITLE, error, CRUDOperation.Get);
                this.requestStatusService.removeBusySpinner("LoadMapDataMnd");
                this.changeDetectorRefs.detectChanges();
            }
        });
    }
    mapLayerData(layer, name) {
        const params = {
            layer,
            name
        };
        this.getMappedLayerDataObservableSubscription = this.mondiService.getMappedLayerDataObservable(this.createApplicationService.moduleID, params).subscribe(data => {
            if (data.region) {
                this.locationForm.get("region").setValue(data.region.regionName);
            }
            else {
                this.locationForm.get("region").setValue(null);
            }
            if (data.area) {
                this.locationForm.get("area").setValue(data.area.areaName);
            }
            else {
                this.locationForm.get("area").setValue(null);
            }
            if (data.wpu) {
                this.locationForm.get("wpu").setValue(data.wpu.wpuCode);
            }
            else {
                this.locationForm.get("wpu").setValue(null);
            }
            if (data.plantation) {
                this.locationForm.get("plantation").setValue(data.plantation.plantationCode);
                this.locationForm.get("compartment").enable();
                this.compartments = [];
                this.selectedCompartmentKey = "";
                this.getCompartmentDataByCode();
            }
            else {
                this.locationForm.get("plantation").setValue(null);
                this.locationForm.get("compartment").disable();
            }
            this.changeDetectorRefs.detectChanges();
        });
    }
    onRegionChange(event) {
        this.requestStatusService.showBusySpinner("GetPropertyDate");
        const element = event.target;
        this.mapComponent.clearGraphics("Mondi module graphics");
        this.mapService.queryMapFeatureByAttribute("Region", `REGION_NAME='${element.value}'`);
        this.areas = this.areasFullList.filter(x => x.region === element.value);
        this.wpus = this.wpusFullList.filter(x => x.region === element.value);
        this.plantations = this.plantationsFullList.filter(x => x.region === element.value);
        this.locationForm.get("compartment").disable();
    }
    onAreaChange(event) {
        this.requestStatusService.showBusySpinner("GetPropertyDate");
        const element = event.target;
        this.mapComponent.clearGraphics("Mondi module graphics");
        this.mapService.queryMapFeatureByAttribute("Area", `AREA_NAME='${element.value}'`);
        this.wpus = this.wpusFullList.filter(x => x.area === element.value);
        this.plantations = this.plantationsFullList.filter(x => x.area === element.value);
        this.locationForm.get("compartment").disable();
    }
    onWPUChange(event) {
        this.requestStatusService.showBusySpinner("GetPropertyDate");
        const element = event.target;
        this.mapComponent.clearGraphics("Mondi module graphics");
        this.mapService.queryMapFeatureByAttribute("WorkPlanUnit", `WPU_CODE='${element.value}'`);
        this.plantations = this.plantationsFullList.filter(x => x.wpu === element.value);
        this.locationForm.get("compartment").disable();
    }
    onPlantationChange(event) {
        this.requestStatusService.showBusySpinner("GetPropertyDate");
        const element = event.target;
        this.mapComponent.clearGraphics("Mondi module graphics");
        this.mapService.queryMapFeatureByAttribute("Plantation", `PLANTATION_CODE='${element.value}'`);
    }
    onCompartmentChange(event) {
        this.requestStatusService.showBusySpinner("GetPropertyDate");
        const element = event.target;
        this.mapComponent.clearGraphics("Mondi module graphics");
        this.mapService.queryMapFeatureByAttribute("Compartment", `SUB_COMPT_KEY='${element.value}'`);
        this.selectedCompartmentKey = element.value;
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: MondiModuleService },
        { type: AppControllerService },
        { type: MapTools },
        { type: MapService },
        { type: NgbModal },
        { type: RequestStatusService },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
CreateApplicationLocationMndComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-create-application-location-mnd",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], CreateApplicationLocationMndComponent);
export { CreateApplicationLocationMndComponent };
